import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/tick.svg';
import { mapGetters } from 'vuex';
import { validateEmail } from '~/helpers/validation-helper';
import isNewProduct from '~/const/patch/newProducts';
import optinProductAvailabilityMutation from '@/graphql/mutation/optinProductAvailability.gql';
export default {
  name: 'TheEmailForm',
  props: {
    locale: {
      type: Object,
      required: true
    },
    reference: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      userEmail: '',
      hasError: false,
      isComplete: false,
      needsChecking: false,
      alertFormMessage: '',
      xhrUri: ''
    };
  },
  computed: _objectSpread({}, mapGetters({
    sharedEnv: 'sharedEnv/getSharedEnv'
  }), {
    comingSoonLabel: function comingSoonLabel() {
      return isNewProduct(this.reference) ? 'new_product_stock' : 'product_stock';
    }
  }),
  methods: {
    handleBlur: function handleBlur(event) {
      if (event.target.value === '') {
        this.hasError = false;
      }

      if (!this.isComplete && event.target.value !== '') {
        this.needsChecking = true;
        this.checkEmail();
      }
    },
    checkIfComplete: function checkIfComplete() {
      this.isComplete = validateEmail(this.userEmail);
    },
    checkEmail: function checkEmail() {
      this.hasError = !validateEmail(this.userEmail);
      this.isComplete = !this.hasError;
      return this.isComplete ? validateEmail(this.userEmail) : null;
    },
    createAlertDispo: function createAlertDispo() {
      var _this = this;

      // Quick sanitize before posting email value
      if (!validateEmail(this.userEmail)) {
        return;
      }

      this.$apolloProvider.defaultClient.mutate({
        mutation: optinProductAvailabilityMutation,
        variables: {
          locale: this.locale.iso,
          reference: this.reference,
          email: this.userEmail
        }
      }).then(function (_ref) {
        var isSuccess = _ref.data.optinProductAvailability;
        _this.alertFormMessage = isSuccess ? 'product_form_confirm' : 'product_form_error';
      });
    }
  }
};